
import {
    getServiceProviderInformation,
    getServiceProviderList,
    registerServiceProviderInformation,
    updateServiceProviderInformation
} from "./api";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderSpId } from "../../../../domain/service_provider/ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "../../../../domain/service_provider/ServiceProviderSharedPassword";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../../app/funcs/orderResultToast";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/ServiceProvider",
    getServiceProviderList: "getList",
    getServiceProviderInformation: "getInformation",
    register: "register",
    update: "update"
});

export const getServiceProviderListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getServiceProviderList}`,
    async (_, { rejectWithValue }) => {
        const data = await getServiceProviderList();

        if (data.error === undefined) {
            // API処理結果正常の場合
            return {
                serviceProviders: data.serviceProviders.map(serviceProvider => {
                    return {
                        ...serviceProvider,
                        spId: "",
                        sharedPassword: "",
                    };
                })
            };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const getServiceProviderInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getServiceProviderInformation}`,
    async (serviceProviderId: ServiceProviderId, { rejectWithValue }) => {
        const data = await getServiceProviderInformation(serviceProviderId);

        if (data.error === undefined) {
            // API処理結果正常の場合
            return {
                serviceProviderInformation: { ...data }
            };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const registerServiceProviderInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.register}`,
    async (data: {
        serviceProviderName: ServiceProviderName,
        serviceProviderSpId: ServiceProviderSpId,
        serviceProviderSharedPassword: ServiceProviderSharedPassword
    }, { rejectWithValue }) => {
        const response = await registerServiceProviderInformation(
            data.serviceProviderName,
            data.serviceProviderSpId,
            data.serviceProviderSharedPassword
        );

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("事業者を登録しました");
            return {};
        } else {
            // API処理結果異常の場合
            const errorMessage = response.error.code === "CONFLICT" ? "SPIDが登録済みです" : "事業者の登録に失敗しました";
            orderErrorToast(errorMessage);
            return rejectWithValue({});
        }
    }
);

export const updateServiceProviderInformationAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.update}`,
    async (data: {
        serviceProviderId: ServiceProviderId,
        serviceProviderName: ServiceProviderName,
        serviceProviderSpId: ServiceProviderSpId,
        serviceProviderSharedPassword: ServiceProviderSharedPassword
    }, { rejectWithValue }) => {
        const response = await updateServiceProviderInformation(
            data.serviceProviderId,
            data.serviceProviderName,
            data.serviceProviderSpId,
            data.serviceProviderSharedPassword
        );

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("事業者を更新しました");
            return {};
        } else {
            // API処理結果異常の場合
            const errorMessage = response.error.code === "CONFLICT" ? "SPIDが登録済みです" : "事業者の更新に失敗しました";
            orderErrorToast(errorMessage);
            return rejectWithValue({});
        }
    }
);
